import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Box, Typography } from '@material-ui/core';
import ErrorOccurredStyles from './ErrorOccurredStyles.style';
import { OCCURRED, SUPPORT } from 'constants/constant';
import { getBaseUrl } from 'helper/utils';

export default function ErrorOccurred() {
	const classes = ErrorOccurredStyles();
	const baseURL = getBaseUrl();
	return (
		<Box id="contact-support-id-meta" alignSelf="center" className={classes.support}>
			<InfoOutlinedIcon fontSize="medium" className={classes.infoIcon} />
			{`${OCCURRED}`}
			<a href={`${baseURL}/support`} target="_blank" rel="noreferrer">
				<Typography component="span" className={classes.padding}>
					{`${SUPPORT}`}
				</Typography>
			</a>
		</Box>
	);
}

ErrorOccurred.propTypes = {
	checked: PropTypes.bool,
	businessName: PropTypes.string,
	hover: PropTypes.bool,
	eComOnly: PropTypes.bool
};
